export default function MapOverlayGrid({ children }) {
  return <div className="grid grid-cols-2 gap-4 mb-3 p-1">{children}</div>;
}
